<template>
    <div class="banner">
        <b-container fluid>
            <b-row>
                <b-col>
                    <img src="../assets/img/imgbanner1.png" class="img-fluid img-full" alt="Banner">
                </b-col>
                <b-col class="align-self-center">
                    <img src="../assets/img/IconoEKbanner.png" class="img-fluid logobanner" alt="Banner">
                </b-col>
                <b-col>
                    <img src="../assets/img/imgbanner2.png" class="img-fluid img-full" alt="Banner">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.col{
    padding: 0;
}
.banner{
    padding-top: 50px;
    background: #D37353;
}

.img-full{
    width: 100%;
}
@media (max-width: 992px){
    .logobanner{
        width: 100px;
    }
}
</style>